import swal from 'sweetalert2';

const BRAND_BLUE = '#366FD0';

// Estilo comum dos dois avisos (Voltar à esquerda, azul da marca).
const CHOICE_OPTIONS = {
    showDenyButton: true,
    showCancelButton: true,
    cancelButtonText: 'Voltar',
    reverseButtons: true,
    confirmButtonColor: BRAND_BLUE,
    denyButtonColor: '#6b7280'
};

// A API recusa com 409 + { duplicate: { kind, requestId, pieceNote } } quando a mesma peça já está
// pronta (SUGGESTION), em cadastro (DRAFT) ou pedida (ACTIVE) a partir desta solicitação.
export const duplicateOf = (error) => error?.response?.data?.duplicate || null;

const askReason = async () => {
    const { isConfirmed, value } = await swal.fire({
        titleText: 'O que diferencia esta peça?',
        text: 'Conte em poucas palavras, para não fazermos a mesma peça duas vezes.',
        input: 'textarea',
        inputPlaceholder: 'Ex.: agravo contra outra decisão (evento 80)',
        inputValidator: (text) =>
            !text || !text.trim() ? 'Conte o que muda em relação à outra peça.' : null,
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Voltar',
        reverseButtons: true,
        confirmButtonColor: BRAND_BLUE
    });
    return isConfirmed ? { action: 'retry', duplicateReason: value.trim() } : { action: 'cancel' };
};

// Devolve o que o cliente escolheu: usar a peça pronta, abrir a já pedida, seguir com motivo ou voltar.
export const resolveDuplicate = async (duplicate) => {
    const piece = duplicate.pieceNote ? `"${duplicate.pieceNote}"` : 'Esta peça';
    const isSuggestion = duplicate.kind === 'SUGGESTION';
    const result = await swal.fire({
        ...CHOICE_OPTIONS,
        ...(isSuggestion
            ? {
                  titleText: 'Esta peça já está pronta para você',
                  text: `Deixamos pronta a peça ${piece}. É a mesma que você quer pedir?`,
                  icon: 'info',
                  confirmButtonText: 'Sim, usar a peça pronta',
                  denyButtonText: 'Não, é outra peça'
              }
            : {
                  titleText: 'Esta peça já foi pedida',
                  text: `${piece} já está na solicitação #${duplicate.requestId}. Pedir de novo faria a mesma peça duas vezes.`,
                  icon: 'info',
                  confirmButtonText: `Ver solicitação #${duplicate.requestId}`,
                  denyButtonText: 'É outra peça'
              })
    });
    if (result.isConfirmed)
        return isSuggestion
            ? { action: 'suggestion' }
            : { action: 'open', requestId: duplicate.requestId };
    if (result.isDenied) return askReason();
    return { action: 'cancel' };
};
